import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ConsumerAccordion({ title, bottomBorder, renderLeftIcon, renderRightPart, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`bo-consumer-accordion ${
        bottomBorder ? 'bo-consumer-accordion-bottom-border' : ''
      }`}
    >
      <Button className="bo-consumer-accordion-top-section" onClick={() => setIsOpen(!isOpen)}>
        <div className="bo-consumer-accordion-icon">
          <FontAwesomeIcon icon={isOpen ? faAngleDown : faAngleRight} size="sm" color="black" />
        </div>
        {renderLeftIcon && renderLeftIcon(isOpen)}
        <p className="bo-consumer-text-bold">{title}</p>
        {renderRightPart && renderRightPart(isOpen)}
      </Button>
      {isOpen && <div className="bo-consumer-accordion-content">{children}</div>}
    </div>
  );
}

export default ConsumerAccordion;
